'use strict';

const ArticleLinks = {
	init: function() {
		this.addLinks();
	},

	addLinks: function() {
		const hElements = document.querySelectorAll('.article__content-box h1, .article__content-box h2');
		const linkElements = document.querySelectorAll('.article__content-link-list > a');
		hElements.forEach((heading) => {
			let headingText = heading.textContent.trim().replace(/:/g, '').toLowerCase();
			headingText = headingText.replace(/[^a-z-]+/g, '-').replace(/-+/g, '-').replace(/^-+|-+$/g, '');
			linkElements.forEach((linkElement) => {
				let specificText = linkElement.textContent.trim().toLowerCase();
				specificText = specificText.replace(/[^a-z-]+/g, '-').replace(/-+/g, '-').replace(/^-+|-+$/g, '');
				if (specificText === headingText) {
					heading.id = headingText;
				}
			});
		});
	},
};

export default ArticleLinks;
